/**
 * TrafficItem
 * 
 * @Author: Focci
 * @Date: 2024-11-19 16:13:14
 * @Last Modified by: Focci
 * @Last Modified time: 2024-11-19 16:13:14
 */

// import PropTypes from 'prop-types'
import { useTranslations } from 'next-intl'
import { useMapState } from '@comp/mapbox'
import OverallItemScoff, { OverallItemSwitch } from '../OverallItemScoff'

export default function TrafficItem() {
  const th = useTranslations('house')
  const mps = useMapState()

  return (
    <OverallItemScoff title={th('commutingToWork')} expanding>
      <OverallItemSwitch
        label={th('commutingToWork')}
        checked={mps.traffic}
        onChange={(e) => mps.valueSetter('traffic', e.target.checked)}
      />
    </OverallItemScoff>
  )
}

// TrafficItem.propTypes = {
//   className: PropTypes.string,
// }
